// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { EntityOut } from './entityOut.zod.ts';

export const ModuleOut = zod.object({
  "entities": zod.array(EntityOut),
  "name": zod.string()
});

export type ModuleOut = zod.input<typeof ModuleOut>;
export type ModuleOutOutput = zod.output<typeof ModuleOut>;
